// src/lib/opportunity/formatPaymentMilestoneResolver.ts

import { listFormatPaymentMilestones } from "./formatPaymentMilestoneClient.js";
import {
  selectFormatPaymentMilestones,
  type FormatPaymentMilestoneDef,
} from "./formatPaymentMilestoneTypes.js";
import type { OpportunityFormatKey } from "../../types/opportunity.js";

export async function resolveFormatPaymentMilestones(args: {
  formatKey: OpportunityFormatKey;
  productType: string;
}): Promise<FormatPaymentMilestoneDef[]> {
  const r = await listFormatPaymentMilestones({
    format_key: args.formatKey,
    product_type: args.productType,
  });
  if (!r.ok) {
    return selectFormatPaymentMilestones({ milestones: [], productType: args.productType });
  }
  return selectFormatPaymentMilestones({
    milestones: r.data.milestones,
    productType: args.productType,
  });
}
